<template>
  <div>
    <!-- Modal editar contacto Pagando -->
    <b-modal
      :id="modalId"
      size="lg"
      hide-header
      hide-footer
      modal-class="modal-default left-oriented"
    >
      <button
        class="close-modal"
        @click="$bvModal.hide('modal-edit-contact-pagando')"
        :aria-label="$t('transfers.beneficiaries.edit.close')"
        :name="$t('transfers.beneficiaries.edit.close')"
      >
        <i aria-hidden="true" class="banana banana-cross-normal"></i>
      </button>
      <div class="head">
        <h2 class="modal-title">{{$t('transfers.beneficiaries.edit.titlePagando')}}</h2>
        <p class="modal-subtitle">{{$t('transfers.beneficiaries.edit.subtitle')}}</p>
      </div>
      <div class="body">
        <BasicInput
          required
          inputId="pagando_tel"
          :label="$t('transfers.beneficiaries.fields.phoneLabel')"
          :inputPlaceholder="$t('transfers.beneficiaries.fields.phonePlaceholder')"
          :inputValue="phone"
          disabled
        >
        </BasicInput>
        <BasicInput
          required
          inputId="pagando_cuenta"
          :label="$t('transfers.beneficiaries.fields.accountLabel')"
          :inputPlaceholder="$t('transfers.beneficiaries.fields.accountPlaceholder')"
          :inputValue="numberAccount"
          disabled
        >
        </BasicInput>
        <BasicInput
          required
          inputId="pagando_nombre_beneficiario"
          :label="$t('transfers.beneficiaries.fields.nameLabel')"
          :inputPlaceholder="$t('transfers.beneficiaries.fields.namePlaceholder')"
          :inputValue="contactName"
          disabled
        >
        </BasicInput>
        <BasicInput
          required
          inputId="pagando_alias"
          :label="$t('transfers.beneficiaries.fields.aliasLabel')"
          :inputPlaceholder="$t('transfers.beneficiaries.fields.aliasPlaceholder')"
          v-model="alias"
        >
        </BasicInput>
      </div>
      <div class="footer">
        <button v-if="!selfContact" type="button" class="button button-ghost button-error" @click="onClickDelete">
          {{$t('transfers.beneficiaries.edit.delete')}}
        </button>
        <button
          v-if="!loading"
          type="button"
          class="button button-filled button-primary"
          :disabled="!alias"
          @click="save"
        >
          {{$t('transfers.beneficiaries.edit.save')}}
        </button>
        <button
          v-else
          type="button"
          class="button button-filled button-primary"
        >
          <LoadingSimple clazz="small-load no-text" />
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import BasicInput from "@/components/BasicInput.vue";
import ToastSnotify from "@/mixins/toastSnotify.mixin";
import ContactsApi from "@/api/wallet/contacts.api";
import LoadingSimple from "@/components/LoadingSimple.vue";

export default {
  name: "ModalEditContactPagando",
  mixins: [ToastSnotify],
  components: {
    BasicInput,
    LoadingSimple,
  },
  data() {
    return {
      modalId: "modal-edit-contact-pagando",
      contactId: null,
      phone: null,
      numberAccount: null,
      contactName: null,
      alias: null,
      loading: false,
      selfContact: false
    };
  },
  mounted() {
    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
      if (modalId === this.modalId) {
        this.clearModal();
      }
    });
  },
  methods: {
    // eslint-disable-next-line
    open(contact) {
      this.contactId = contact._id;
      this.phone = contact.phone;
      this.numberAccount = contact.numberAccount;
      this.contactName = contact.contactName;
      this.alias = contact.alias;
      this.selfContact = contact.selfContact;

      this.$bvModal.show(this.modalId);
    },
    clearModal() {
      this.contactId = null;
      this.phone = null;
      this.numberAccount = null;
      this.contactName = null;
      this.alias = null;
      this.loading = false;
    },
    async save() {
      this.loading = true;
      try {
        await ContactsApi.edit({
          contactId: this.contactId,
          alias: this.alias,
        });
        this.$emit("onSave");
        this.$bvModal.hide(this.modalId);
      } catch (error) {
        this.toastErrorDefault(error);
        this.loading = false;
      }
    },
    async onClickDelete() {
      this.$bvModal.hide(this.modalId);
      this.$emit('delete');
    },
  },
};
</script>
